/**
 * LuxClub – Product image slider → COLOR option auto-sync v7
 *
 * v7 change: replaced dragEnd + uiChange listeners with a single 'change'
 * listener so that ALL navigation methods (touch swipe, Flickity built-in
 * arrows, AND custom JS prev/next buttons) trigger the color sync.
 *
 * Loop-safety: syncColorFromSlider() only calls matched.click() when the
 * button is NOT already checked, so a color-button click that moves the
 * slider will not create an infinite loop.
 */
(function () {
  'use strict';

  function syncColorFromSlider(flickityInstance, sliderEl) {
    var idx = flickityInstance.selectedIndex;
    var slides = sliderEl.querySelectorAll('.product-main-slide');
    var selected = slides[idx] || sliderEl.querySelector('.product-main-slide.is-selected');
    if (!selected) return;

    var img = selected.querySelector('img');
    if (!img) return;

    var colorAlt = (img.getAttribute('alt') || '').trim();
    if (!colorAlt) return;

    var colorWrapper =
      document.querySelector('.variant-input-wrap[data-handle="color"]') ||
      document.querySelector('.variant-input-wrap[data-index="option1"]');
    if (!colorWrapper) return;

    var matched = null;
    colorWrapper.querySelectorAll('[data-variant-input]').forEach(function (btn) {
      var val = (btn.value || btn.getAttribute('value') || '').trim();
      if (val.toLowerCase() === colorAlt.toLowerCase()) matched = btn;
    });

    /* Only click if not already selected — prevents infinite loops */
    if (matched && !matched.checked) matched.click();
  }

  function attachToFlickity(sliderEl) {
    if (!sliderEl || sliderEl._luxColorSyncDone) return;

    var fi = window.Flickity && window.Flickity.data && window.Flickity.data(sliderEl);
    if (!fi) return;

    sliderEl._luxColorSyncDone = true;

    /*
     * v7: listen to 'change' instead of dragEnd + uiChange.
     * 'change' fires for ALL navigation: swipe, built-in arrow/dot,
     * AND programmatic flkty.previous() / flkty.next().
     * This ensures custom arrow buttons also trigger color sync.
     */
    fi.on('change', function () {
      syncColorFromSlider(fi, sliderEl);
    });
  }

  function tryAttach() {
    var sliders = document.querySelectorAll('[data-product-photos]');
    var pending = 0;
    sliders.forEach(function (el) {
      if (!el._luxColorSyncDone) {
        attachToFlickity(el);
        if (!el._luxColorSyncDone) pending++;
      }
    });
    return sliders.length > 0 && pending === 0;
  }

  function init() {
    if (tryAttach()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (tryAttach() || attempts > 40) clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('quickview:loaded', init);
  document.addEventListener('modalProduct:loaded', init);
})();
